import React from "react"
import styled from "styled-components"
import { ChevronRight } from "react-feather"
import pdfIcon from "../images/pdf-icon.svg"
import docxIcon from "../images/docx-icon.svg"
import movIcon from "../images/mov-icon.svg"
import mp4Icon from "../images/mp4-icon.svg"
import wavIcon from "../images/wav-icon.svg"
import xlsIcon from "../images/xls-icon.svg"
import zipIcon from "../images/zip-icon.svg"
import quizIcon from "../images/quiz-icon.svg"
import ExternalLink from "./externalLink"
import SecondaryLinks from "./secondaryLinks"

const Resources = ({ resources, links }) => (
  <Wrapper>
    <List>
      {resources.map(resource => (
        <li key={resource.originalId}>
          <SecondaryLinks>
            <ExternalLink href={resource.url}>
              {resource.title} {getIcon(resource.format)}
            </ExternalLink>
          </SecondaryLinks>
        </li>
      ))}
      {links && (
        <>
          {links.map(link => (
            <li key={link.originalId}>
              <SecondaryLinks>
                <ExternalLink href={link.url}>
                  {link.anchor} {getIcon("quiz")}
                </ExternalLink>
              </SecondaryLinks>
            </li>
          ))}
        </>
      )}
    </List>
  </Wrapper>
)

function getIcon(format) {
  switch (format) {
    case "pdf":
      return <img src={pdfIcon} />
    case "docx":
      return <img src={docxIcon} />
    case "mov":
      return <img src={movIcon} />
    case "mp4":
      return <img src={mp4Icon} />
    case "mp3":
      return <img src={wavIcon} />
    case "xls":
      return <img src={xlsIcon} />
    case "zip":
      return <img src={zipIcon} />
    case "quiz":
      return <img src={quizIcon} />
    default:
      return <ChevronRight size={24} />
  }
}

const Wrapper = styled.div``

const List = styled.ul`
  list-style: none;
  margin: 0;
  & > li {
    margin: 0;
  }
`

export default Resources
